import { gl } from '../context.js'
import * as glm from 'gl-matrix'

function Draw(scene) {
  // use program shader
  gl.useProgram(this.shader.program);

  // matrices
  gl.uniformMatrix4fv(this.shader.uniforms.projectionMatrix, false, scene.projectionMatrix);
  gl.uniformMatrix4fv(this.shader.uniforms.viewMatrix, false, scene.viewMatrix);
  gl.uniformMatrix4fv(this.shader.uniforms.modelMatrix, false, this.modelMatrix);

  // texture
  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, this.texture);
  gl.uniform1i(this.shader.uniforms.wordsTexture, 0);

  // draw this
  this.mesh.Draw(this.shader);
}

function Update(delta) {
  // glm.mat4.rotateZ(this.modelMatrix, this.modelMatrix, this.rotation * delta);
}

function Model(assets) {
  return {
    mesh: assets[0],
    shader: assets[1],
    texture: assets[2],
    modelMatrix: glm.mat4.fromTranslation(glm.mat4.create(), [0, 0, 0]),
    Draw,
    Update,
    rotation: Math.random() - 0.5
  };
}

export { Model }
